import { APP_NAME, APP_NAME_FULL } from './app';

export const siteTitle = APP_NAME_FULL;
export const seoAlternateName = APP_NAME;
export const seoDomain = 'https://www.maritimemuseum.co.nz';
export const seoImagePath = 'https://www.maritimemuseum.co.nz/static/assets/images/logo.71558d69e1e7d42ef983.svg';

export const ORGANIZATION_PHONE = '+64 9 373 0800';
export const ORGANIZATION_EMAIL = 'info@maritimemuseum.co.nz';
export const ORGANIZATION_ADDRESS = {
    '@type': 'PostalAddress',
    streetAddress: 'Corner Quay and Hobson streets, Viaduct Harbour',
    addressLocality: 'Auckland',
    addressCountry: 'NZ'
};

export const SOCIAL_URLS = [
    'https://www.facebook.com/nzmaritimemuseum',
    'https://www.youtube.com/channel/UCGvYjwhqU86GoB8V2Unc02A',
    'https://www.instagram.com/nzmaritimemuseum/'
];

// Keep this entity identical to the shared parent emitted by the Art Gallery schema.
export const PARENT_ORGANIZATION = {
    '@type': 'Organization',
    '@id': 'https://www.aucklandunlimited.com/#organization',
    name: 'Tātaki Auckland Unlimited',
    alternateName: ['Auckland Unlimited', 'TAU'],
    url: 'https://www.aucklandunlimited.com/',
    logo: {
        '@type': 'ImageObject',
        url: 'https://aucklandunlimited.com/static/assets/images/tataki-auckland-unlimited-a-navy-rgb.26dbb9e1deac145cabbb.svg'
    },
    sameAs: [
        'https://www.linkedin.com/company/auckland-unlimited',
        'https://www.wikidata.org/wiki/Q55764471'
    ]
};
